export function getChampionMatchId() {
  const env = process.env.VUE_APP_DEV_MODE || process.env.VUE_APP_ENV || '';
  if (['development', 'test', 'stag'].includes(env)) {
    return 741587;
  }
  return 1122398;
}
